import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
function connectComponent(mapStateToProps, actions, component) {
    return withRouter(connect(mapStateToProps, actions, null, { pure: true })(component));
}
export { connectComponent };
//# sourceMappingURL=index.js.map